import React from 'react';
import { Story } from './components/Story';
import { BeforeAfter } from './components/BeforeAfter';
import { ParentsStory } from './components/ParentsStory';
import { Benefits } from './components/Benefits';
import { NourixInfo } from './components/NourixInfo';
import { AdDisclosure } from './components/AdDisclosure';
import { BlogHeader } from './components/BlogHeader';
import { ErrorBoundary } from './components/ErrorBoundary';
export function App() {
  return <ErrorBoundary data-id="element-0">
      <div className="w-full min-h-full bg-stone-50 text-gray-800 font-sans" data-id="element-1">
        <AdDisclosure data-id="element-2" />
        <BlogHeader data-id="element-3" />
        <div className="max-w-4xl mx-auto px-4 py-8" data-id="element-4">
          <Story data-id="element-5" />
          <BeforeAfter data-id="element-6" />
          <ParentsStory data-id="element-7" />
          <Benefits data-id="element-8" />
          <NourixInfo data-id="element-9" />
          <div className="text-xs text-gray-500 text-center mt-12 border-t pt-6" data-id="element-10">
            <p data-id="element-11">
              Detta inlägg är skrivet av en oberoende affiliate och innehåller
              mina personliga erfarenheter. Resultaten kan variera från person
              till person.
            </p>
            <p data-id="element-12">Publicerad: 15 maj 2023 | Uppdaterad: 3 juni 2023</p>
          </div>
        </div>
      </div>
    </ErrorBoundary>;
}